import { useEffect, useState } from "react";
import vestelKimlik from "../assets/images/vestelKimlik.png";
import redirect1 from "../assets/images/redirect1.png";
import vestelLogo1 from "../assets/images/vestelLogo1.png";
import evinAkli1 from "../assets/images/Vestel_Akilli_Yasam_ikon_final.png";
import vfit1 from "../assets/images/Vestel_Akilli_Saglik_ikon_final.png";
import regal1 from "../assets/images/regal1.png";
import vsOutlet1 from "../assets/images/vsOutlet1.png";
import vestelCozum1 from "../assets/images/vestelCozum1.png";
import RedirectImage from "../assets/images/redirectImage.png";
import useMediaQuery from "../hooks/useMediaQuery";
import { useTranslation } from "react-i18next";

export default function VestelIdentity() {
  const isSmallScreen = useMediaQuery("(max-width:785px)");
  const [evinAkli, setEvinAkli] = useState("");
  const [vfit, setVfit] = useState("");
  const { t, i18n } = useTranslation();
  const [storeUrl, setStoreUrl] = useState(
    `${process.env.REACT_APP_STORE_URL}customer/login`
  );

  useEffect(() => {
    if (i18n.language == "tr") {
      setStoreUrl(`${process.env.REACT_APP_STORE_URL}customer/login`);
    } else if (i18n.language == "de") {
      setStoreUrl(`${process.env.REACT_APP_GLOBAL_STORE_URL}customer/login`);
    }
  }, [i18n.language]);

  useEffect(() => {
    let userDevice = navigator.userAgent || window.opera;
    if (/iPad|iPhone|iPod/.test(userDevice) && !window.MSStream) {
      setEvinAkli("https://apps.apple.com/tr/app/evin-aklı/id966916050");
      setVfit("https://apps.apple.com/tr/app/vfit/id1491459940");
    } else {
      setEvinAkli(
        "https://play.google.com/store/apps/details?id=com.smarthome.core.main&hl=tr"
      );
      setVfit(
        "https://play.google.com/store/apps/details?id=com.vestel.vfitplus"
      );
    }
  });

  return (
    <div className="redirect-page">
      <div className="content-page identity-content-page">
        <div className="identity-overflow">
          <img
            className="vestel-kimlik-img"
            src={vestelKimlik}
            alt="vestel-kimlik"
          />
          <div>
            <div className="identity-position">
              VESTEL {t("redirect.title")}
            </div>
            <div className="identity-absolute">{t("redirect.description")}</div>
          </div>
        </div>
        <div
          style={{
            display: "block",
            position: "absolute",
            top: "110%",
          }}
        >
          <div>
            <img className="redirect-image" src={redirect1} alt="redirect1" />
          </div>
        </div>
        <div className="redirect-p-title">
          <p className="redirect-p-center">{t("redirect.now")},</p>
          <p className="redirect-p-center-bold">{t("redirect.youWantLogin")}</p>
          <p className="redirect-p-center-bold">
            {t("redirect.websiteOrApplication")}
          </p>
          <p className="redirect-p-center-bold">{t("redirect.click")}.</p>
          {isSmallScreen ? (
            <>
              <div className="sign-in-div">
                <a href={storeUrl}>
                  <div className="sign-in-square">
                    <img
                      className="sign-in-img"
                      src={vestelLogo1}
                      alt="vestelLogo1"
                    />
                    <p className="sign-in-redirect-website">
                      {t("redirect.goToWebsite")}
                      <img src={RedirectImage} alt="redirectImage" />
                    </p>
                  </div>
                </a>
                <a href={evinAkli}>
                  <div className="sign-in-square">
                    <img
                      style={{ width: "50px" }}
                      className="sign-in-img"
                      src={evinAkli1}
                      alt="evinAkli1"
                    />
                    <p className="sign-in-img-p">{t("redirect.smartLife")}</p>
                    <p className="sign-in-redirect-website">
                      {t("redirect.goToApplication")}
                      <img src={RedirectImage} alt="redirectImage" />
                    </p>
                  </div>
                </a>
                <a href={vfit}>
                  <div className="sign-in-square">
                    <img
                      style={{ width: "50px" }}
                      className="sign-in-img"
                      src={vfit1}
                      alt="vfit1"
                    />
                    <p className="sign-in-img-p">{t("redirect.smartHealth")}</p>
                    <p className="sign-in-redirect-website">
                      {t("redirect.goToApplication")}
                      <img src={RedirectImage} alt="redirectImage" />
                    </p>
                  </div>
                </a>
              </div>
              <div className="sign-in-div">
                <a href="https://www.regal-tr.com/customer/login">
                  <div className="sign-in-square">
                    <img className="sign-in-img" src={regal1} alt="regal1" />
                    <p className="sign-in-redirect-website">
                      {t("redirect.goToWebsite")}
                      <img src={RedirectImage} alt="redirectImage" />
                    </p>
                  </div>
                </a>
                <a href="https://www.vsoutlet.com.tr/customer/login">
                  <div className="sign-in-square">
                    <img
                      className="sign-in-img"
                      src={vsOutlet1}
                      alt="vestelLogo1"
                    />
                    <p className="sign-in-redirect-website">
                      {t("redirect.goToWebsite")}
                      <img src={RedirectImage} alt="redirectImage" />
                    </p>
                  </div>
                </a>
                <a href={process.env.REACT_APP_SUPPORT_URL}>
                  <div className="sign-in-square">
                    <img
                      className="sign-in-img"
                      src={vestelCozum1}
                      alt="vestelCozum1"
                    />
                    <p className="sign-in-redirect-website">
                      {t("redirect.goToWebsite")}
                      <img src={RedirectImage} alt="redirectImage" />
                    </p>
                  </div>
                </a>
              </div>
            </>
          ) : (
            <>
              <div className="sign-in-div">
                <a href={storeUrl}>
                  <div className="sign-in-square">
                    <img
                      className="sign-in-img"
                      src={vestelLogo1}
                      alt="vestelLogo1"
                    />
                    <p className="sign-in-redirect-website">
                      {t("redirect.goToWebsite")}
                      <img src={RedirectImage} alt="redirectImage" />
                    </p>
                  </div>
                </a>
                <a href={evinAkli}>
                  <div className="sign-in-square">
                    <img
                      style={{ width: "50px" }}
                      className="sign-in-img"
                      src={evinAkli1}
                      alt="evinAkli1"
                    />
                    <p className="sign-in-img-p">{t("redirect.smartLife")}</p>
                    <p className="sign-in-redirect-website">
                      {t("redirect.goToApplication")}
                      <img src={RedirectImage} alt="redirectImage" />
                    </p>
                  </div>
                </a>
                <a href={vfit}>
                  <div className="sign-in-square">
                    <img
                      style={{ width: "50px" }}
                      className="sign-in-img"
                      src={vfit1}
                      alt="vfit1"
                    />
                    <p className="sign-in-img-p">{t("redirect.smartHealth")}</p>
                    <p className="sign-in-redirect-website">
                      {t("redirect.goToApplication")}
                      <img src={RedirectImage} alt="redirectImage" />
                    </p>
                  </div>
                </a>
                <a href="https://www.regal-tr.com/customer/login">
                  <div className="sign-in-square">
                    <img className="sign-in-img" src={regal1} alt="regal1" />
                    <p className="sign-in-redirect-website">
                      {t("redirect.goToWebsite")}
                      <img src={RedirectImage} alt="redirectImage" />
                    </p>
                  </div>
                </a>
                <a href="https://www.vsoutlet.com.tr/customer/login">
                  <div className="sign-in-square">
                    <img
                      className="sign-in-img"
                      src={vsOutlet1}
                      alt="vestelLogo1"
                    />
                    <p className="sign-in-redirect-website">
                      {t("redirect.goToWebsite")}
                      <img src={RedirectImage} alt="redirectImage" />
                    </p>
                  </div>
                </a>
                <a href={process.env.REACT_APP_SUPPORT_URL}>
                  <div className="sign-in-square">
                    <img
                      className="sign-in-img"
                      src={vestelCozum1}
                      alt="vestelCozum1"
                    />
                    <p className="sign-in-redirect-website">
                      {t("redirect.goToWebsite")}
                      <img src={RedirectImage} alt="redirectImage" />
                    </p>
                  </div>
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
